// extracted by mini-css-extract-plugin
export default {"root":"WogUI__root","mainContentSlot":"yQvqx__mainContentSlot","mainContentSidebarOpen":"kVzP3__mainContentSidebarOpen"};